import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ObjectNode } from 'src/app/services/object-list.service';
import { TooltipValues } from '../metrics/metrics.component';
import { MetricsService } from 'src/app/services/metrics.service';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatTooltip } from '@angular/material/tooltip';
import { NgIf, DatePipe } from '@angular/common';
import { TimeFormatPipe } from '../../pipes/time-format.pipe';

@Component({
    selector: 'app-metrics-header-assembly',
    templateUrl: './metrics-header-assembly.component.html',
    styleUrls: ['./metrics-header-assembly.component.scss'],
    imports: [MatCard, MatCardTitle, MatTooltip, NgIf, MatCardContent, DatePipe, TimeFormatPipe]
})
export class MetricsHeaderAssemblyComponent implements OnInit, OnDestroy {

  @Input() object:ObjectNode;
  @Input() section:string="problems";
  
  tooltipValues:TooltipValues = new TooltipValues();

  metricsHeaderSub$: Subscription;
  metricsHeaderData:any = {};
  tooltipValuePerfect:string = this.tooltipValues.perfect;
  tooltipValueTarget:string = this.tooltipValues.target;

  constructor(
    private svcMetrics:MetricsService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    if (this.metricsHeaderSub$) this.metricsHeaderSub$.unsubscribe();
    let offset:string = (new Date().getTimezoneOffset() / 60).toString().padStart(4, "0");

    this.metricsHeaderSub$ = this.svcMetrics.metricsHeader(this.object).subscribe(
      out => {
        if (out) {
          this.metricsHeaderData = out.Body.PRODUCTION;

          this.metricsHeaderData.EventStart = new Date(Date.parse(this.metricsHeaderData.EventStart + "-" + offset));

          if (this.metricsHeaderData.idealCycleTime !=0) {
            this.tooltipValues.perfect = this.tooltipValuePerfect + '\n' + "(Ideal Cycle Time = " + this.metricsHeaderData.idealCycleTime.toFixed(2) + ")"
          }

          if (this.metricsHeaderData.totalTargetDemand !='') {
            this.tooltipValues.target  = this.tooltipValueTarget +  '\n' + "(Total Shift Target = " + this.metricsHeaderData.totalTargetDemand + ")"
          }
        }
      }
    );
  }

  navigateToCurrentProblem(e:Event):void { 
    e.stopPropagation(); // Prevent this from progating to click event on outter DIV
  }

  floor(value:number):number {
    return Math.floor(value);
  }

  ngOnDestroy(): void{ 
    if (this.metricsHeaderSub$) this.metricsHeaderSub$.unsubscribe();
    this.svcMetrics.cleanupObservers();
  }
}
